import api from "./api";

export interface ProjectBookingPending {
  projectId: number;
  projectName: string;
  freshBooking: number;
  edits: number;
  transfer: number;
}

export interface ProjectIncomePending {
  projectId: number;
  projectName: string;
  incomeCount: number;
  incomeTotal: number;
  hiddenIncomeCount: number;
  hiddenIncomeTotal: number;
}

export interface AuthorizationDashboardData {
  success: boolean;
  bookingPending: ProjectBookingPending[];
  bookingTotals: {
    freshBooking: number;
    edits: number;
    transfer: number;
  };
  incomePending: ProjectIncomePending[];
  incomeTotals: {
    incomeCount: number;
    incomeTotal: number;
    hiddenIncomeCount: number;
    hiddenIncomeTotal: number;
  };
}

export const getAuthorizationDashboard = async (): Promise<AuthorizationDashboardData> => {
  const response = await api.get("/authorization-dashboard");
  return response.data;
};
